"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CONSULT = exports.PROPERTY = exports.CASE = void 0;
var CASE = 'case';
exports.CASE = CASE;
var PROPERTY = 'property';
exports.PROPERTY = PROPERTY;
var CONSULT = 'consult';
exports.CONSULT = CONSULT;